// extracted by mini-css-extract-plugin
export var nav = "header-module--nav--106zH";
export var brand = "header-module--brand--1lMzv";
export var logo = "header-module--logo--3gIix";
export var label = "header-module--label--3wCnA";
export var active = "header-module--active--2DNib";
export var flexible = "header-module--flexible--34SCi";